<template>
  <!-- 代码乱的跟小可爱一样， 我看谁在开发乱放代码。 Please 参考 -> https://bytedance.feishu.cn/docx/doxcntqHE6mxLE4WDSetL2x2TRe -->
  <div ref="tipsContainerNode" class="global-tips-container">
    <!-- 1 全局推送  -->
    <!-- 全局推送消息，必须是第一位的，不能被其他小蓝条遮蔽且无法被关闭 -->
    <!-- 参考使用场景，平台需要进入维护，开启该白名单，给所有用户强推维护文案，处于第一位且无法被关闭，和其他所有提示不能共存 -->
    <div>
      <byted-alert  v-if="globalPushEnable&&tipsTag==='globalPushEnable'"
                  type="warning">
        <div v-html="globalPushText"></div>
        <span>{{tracerShow({ tipsLevel, text: globalPushText, tipsTag })}}</span>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 2 教育全量提示下线 -->
    <div>
      <byted-alert
        closable
        type="warning"
        v-if="showEducationFullAlert && tipsTag === 'showEducationFullAlert'"
        @close="onCloseVerticalEducationFullRemind"
      >
        {{ industryOfflineTips.education.preOfflineTips }}<a
        target="_blank"
        @click="() => tracerClick({ tipsLevel, tipsTag, })"
        :href="globalUpdateQuery(dpaLibraryListUrl)"
      >立即新建</a>
        <span>{{tracerShow({ tipsLevel, tipsTag, text: `${industryOfflineTips.education.preOfflineTips}立即新建` })}}</span>
        <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 5 广告主状态 -->
    <div>
      <byted-alert  v-if="showAdvStatusAlert&&tipsTag==='showAdvStatusAlert'"
                    type="warning"
                    closable
                    @close="onCloseAdvStatus">
        <div v-html="this.advMsg"></div>
        <span>{{tracerShow({ tipsLevel, tipsTag, text: this.advMsg })}}</span>
        <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 6 方舟存量治理 -->
    <div>
      <byted-alert  v-if="showUpgrafeNotifyStatusAlert&&tipsTag === 'showUpgrafeNotifyStatusAlert'"
        type="warning"
        closable
        @close="(e) => hideUpgrafeNotifyStatusAlert(e)"
      >
        <span>{{ upgrafeNotifyStatus.text || '' }}</span>
        <span>{{ tracerShow({tipsLevel, tipsTag, text: ''}) }}</span>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 3 合同相关。 签署 -->
    <div>
      <byted-alert  v-if="showSupplementAlert&&tipsTag==='showSupplementAlert'"
                  type="warning"
                  closable
                  @close="onCloseSupplement">
        为进一步提高账户安全性，保障广告账户正常投放，您需要补充或更新合同授权联系人信息，请前往填写，并完成协议签署。
        <a target="_blank" :href="globalUpdateQuery(`/pages/account/contract_sign.html?curindex=1&type=2&contId=${this.cont_id}&origin=2`)" @click="supplementTrack">去补充</a>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 4 合同相关。 续签-->
    <div>
      <byted-alert  v-if="showExtentionAlert&&tipsTag==='showExtentionAlert'"
                  type="warning"
                  closable
                  @close="onCloseExtention">
      您好，您当前的合同有效期至{{end_time}}，为不影响您2023年在本平台正常投放，您需要完成合同续签，请尽快前往签署。
        <a target="_blank" :href="globalUpdateQuery(this.isList ? `/pages/account/contract_sign.html` : `/pages/account/contract_sign.html?curindex=1&type=3&datatime=${this.datatime}&origin=2`)" @click="extensionTrack">去签署</a>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 6 余额为零-->
    <div>
      <byted-alert  v-if="showNoBalanceAlert&&tipsTag==='showNoBalanceAlert'"
                  type="warning"
                  closable
                  @close="onCloseNoBalance">
        {{ $bp_t('当前账户余额为零，请立即充值，避免影响广告投放。', 'bp.promotion_the_current_account') }}
        <a target="_blank"
          :href="globalUpdateQuery(rechareUrl)"
          @click="() => tracerClick({ tipsLevel, tipsTag })"
          data-log="{'type':'recharge-from','title':'余额为零-小黄条-立即充值','delay':true}">{{ $bp_t('立即充值', 'bp.promotion_immediate_recharge') }}</a>
        <span>
          {{
            tracerShow({
              tipsLevel,
              tipsTag,
              text:  $bp_t(
                '当前账户余额为零，请立即充值，避免影响广告投放。',
                'bp.promotion_the_current_account')
                + $bp_t('立即充值', 'bp.promotion_immediate_recharge')
              })
          }}
        </span>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 7 账户诊断提示 -->
    <div>
      <byted-alert  v-if="showAccountDiagnosisAlert&&tipsTag === 'showAccountDiagnosisAlert'"
        type="warning"
        closable
        @close="(e) => hideAccountDiagnosis(e)"
      >
        <span>{{ accountDiagnosisData.frontText[0] || '' }}</span>
        <a @click="() => tracerClick({ tipsLevel, tipsTag, text: '' })" :href="accountDiagnosisData.frontLink" target="_blank">{{ accountDiagnosisData.frontText[1] || '' }}</a>
        <span>{{ accountDiagnosisData.frontText[2] || '' }}</span>
        <span>{{ tracerShow({tipsLevel, tipsTag, text: ''}) }}</span>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 8 Quota防hack平台预警和惩罚提示 信息流 -->
    <div>
      <byted-alert
         v-if="showQuotaHackFeedAlert&&tipsTag === 'showQuotaHackFeedAlert'"
        type="warning"
        closable
        @close="(e) => hideQuotaHackFeedAlert(e)"
      >
        <span>{{ getHackText('feed') }}</span>
        <a :href="quotaLink" target="_blank">清理低效计划</a>
        。
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

    <!-- 9 Quota防hack平台预警和惩罚提示 搜索 -->
    <div>
      <byted-alert
         v-if="showQuotaHackSearchAlert&&tipsTag === 'showQuotaHackSearchAlert'"
        type="warning"
        closable
        @close="(e) => hideQuotaHackSearchAlert(e)"
      >
        <span>{{ getHackText('search') }}</span>
        <a :href="quotaLink" target="_blank">清理低效计划</a>
      <div v-if="!isLastTip" slot="close" class="close-text">下一条</div></byted-alert>
    </div>

  </div>
</template>

<script>
  // AD后台全局提示汇总：https://bytedance.feishu.cn/space/doc/doccnXgIoaUZqZaCUAv77NvydHh#

  import Apis from 'Src/const/apis'
  import json from 'Src/util/json.js'
  import tool from 'Src/util/tool'
  import { advStatusMessage, advertiserStatus, NotifyStatusEnum } from 'Src/const/state/account.js'
  import { industryOfflineTips } from 'Src/const/state/common.js'
  import dayjs from 'dayjs'
  import businessAccount from 'Src/const/apis/business-account'
  const QuickSearchToSearch = () => import('Src/components/promotion/quick-search-to-search.vue')
  const QuickTurnAutoModal = () => import('Src/components/promotion/quick-search-turn-auto.vue')
  const showid = Math.random().toString(36).slice(2);
  // 优先级列表
  // 千万不能改原有数据字段，因为影响到展示
  // 优先级列表建议先看文档注意展示顺序 ！！！极其重要，不然会导致其他提示条无法正常展示
  // 具体逻辑参考 https://bytedance.feishu.cn/docs/doccnssWHkENVdnWQbvhLTQ9m7c#
  const alertStatusList = [
    'globalPushEnable', // 全局
    'showEducationFullAlert', // 教育下线
    'showAdvStatusAlert', // 账户状态
    'showUpgrafeNotifyStatusAlert', // 方舟状态提示
    'showSupplementAlert', // 合同
    'showExtentionAlert', // 合同
    'showNoBalanceAlert', // 余额为 0
    'showAccountDiagnosisAlert', // 账户诊断提示
    'showQuotaHackFeedAlert', // Quota防hack平台预警和惩罚提示 信息流
    'showQuotaHackSearchAlert', // Quota防hack平台预警和惩罚提示 搜索流
  ];
  const advStatus = ['']

  export default {
    name: 'global-tips',
    components: {
      QuickSearchToSearch,
      QuickTurnAutoModal
    },
    computed: {
      // quota跳转链接
      quotaLink () {
        return `/bp/analytics/tools_ad.html?from=quota_yellow_bar&aadvid=${GLOBAL_VAR.advertiser.id}#/clear-helper/index/low-quality?diagnosisTag=0`
      },
      // 通过此字段处理小黄条显示优先级
      tipsLevel () {
        for (let i = 0; i < alertStatusList.length; i++) {
          if (this[alertStatusList[i]]) return i;
        }
      },
      isSupportAwemeBind () {
        return tool.isSupported(GLOBAL_VAR?.adver_func?.new_douyin_auth)
      },
      tipsTag () {
        return alertStatusList[this.tipsLevel]
      },
      showAdvStatusAlert () {
        let message = ''
        // GLOBAL_VAR.advertiser.status = '7'
        const status = +GLOBAL_VAR.advertiser.status
        message = advStatusMessage[status]

        switch (status) {
          case 0:
          case 1:
          case 2:
          case 5:
          case 6:
          case 9:
          case 12:
            break
          case 3:
          case 14:
            // message = message.replace('{path}', this.isShowAuthCenterNotice ? 'auth' : 'info')
            //   .replace('认证中心', this.isShowAuthCenterNotice ? '认证中心' : '账号信息')
            break
          case 8:
            //const punishReason = //GLOBAL_VAR.advertiser.punishReason
            message = message.replace('{punishReason}', this.punishReason.join(',')).replace('{punishTime}', this.punishTime)
            break
          case 7:
            // message = message.replace('{path}', this.isShowAuthCenterNotice ? 'auth' : 'info')
            //   .replace('认证中心', this.isShowAuthCenterNotice ? '认证中心' : '账号信息')
            break
          case 10:
            // message = message.replace('{path}', this.isShowAuthCenterNotice ? 'auth' : 'info')
            //   .replace('认证中心', this.isShowAuthCenterNotice ? '认证中心' : '账号信息')
            if (json.catchableParse(GLOBAL_VAR.isChargeDiscount)) {
              message = ''
            }
            break
          default:
            message = '' // 13 不处理 有额外的点击触发逻辑
        }
        this.advMsg = message

        const msgNotEmpty = (message !== '')
        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showAdvStatus))

        return (msgNotEmpty && this.showAdvStatus && !timeLessThanOneDay)
      },
      showSupplementAlert () {
        return this.showSupplement
      },
      showExtentionAlert () {
        return this.showExtention
      },
      end_time() {
        return dayjs(Number(this.datatime)).format('YYYY年MM月DD日')
      },
      showPaySMBAlert () {
        // const isShowAccountFee = (GLOBAL_VAR.advertiser.status ===
        // advertiserStatus.STATUS_WAIT_FOR_ACCOUNT_FEE.toString())

        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showPaySMB))

        return (this.showPaySMB && this.isShowAccountFee && !timeLessThanOneDay)
        // return true
      },
      showNoBalanceAlert () {
        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showNoBalance))

        return (this.showNoBalance && this.noValidBalance && !timeLessThanOneDay)
      },
      smbNeedCharge () {
        return (this.smbPayModal.accountFee >= this.smbPayModal.cashBalance)
        // return true
      },
      showDiagnosisAlert () {
        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showDiagnosis))
        const isPromotionPage = (window.location.pathname === '/pages/promotion.html')

        return (this.showDiagnosis && isPromotionPage && !timeLessThanOneDay)
      },
      showAccountDiagnosisAlert () {
        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showAccountDiagnosis))
        const isPromotionPage = (window.location.pathname === '/pages/promotion.html')

        return (this.showAccountDiagnosis && isPromotionPage && !timeLessThanOneDay)
      },
      // 是否展示方舟账户状态
      showUpgrafeNotifyStatusAlert () {
        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showUpgrafeNotifyStatus))
        return this.showUpgrafeNotifyStatus && !timeLessThanOneDay
      },
      // 是否展示quota 信息流
      showQuotaHackFeedAlert () {
        return this.showQuotaHackFeedStatus && [1, 2, 3].includes(this.hackStatus.feed)
      },
      // 是否展示quota 搜索
      showQuotaHackSearchAlert () {
        return this.showQuotaHackSearchStatus && [1, 2, 3].includes(this.hackStatus.search)
      },
      // 教育库全量提醒
      showEducationFullAlert () {
        const timeLessThanSevenDay = this.timeLessThan(this.Keys.showEducationFullIndustryRemind, this.oneDayMillSeconds * 6);
        return this.showEducationFullIndustryRemind && this.educationFullIndustryRemind && !timeLessThanSevenDay
      },
    },
    data () {
      return {
        isLastTip: false,
        closeTimeTag: '_GlobalTips_',
        oneDayMillSeconds: 86400000, // 24 * 60 * 60 * 1000
        showActivityByUser: true,
        Keys: {
          showActivity: 'showActivity',
          showNoBalance: 'showNoBalance',
          showAdvStatus: 'showAdvStatus',
          showDiagnosis: 'showDiagnosis',
          showAccountDiagnosis: 'showAccountDiagnosis',
          showUpgrafeNotifyStatus: 'showUpgrafeNotifyStatus',
          showVerticalCarOfflineRemind: 'showVerticalCarOfflineRemind',
          showEducationFullIndustryRemind: 'showEducationFullIndustryRemind',
          showFeed2Search2Search: 'showFeed2Search2Search',
          showQuickTurnAuto: 'showQuickTurnAuto',
          showBindBp: 'showBindBp',
        },
        urls: {
          'bpAdAccount': 'https://business.oceanengine.com/site/setting/adv-account',
          'bpBizAccount': 'https://business.oceanengine.com/site/setting/ies-biz-account',
          'refound': 'https://ad.oceanengine.com/cg_trade/finance/wallet?from_app=ad&aadvid=' + GLOBAL_VAR.advertiser.id
        },
        alertText: {
          bindBp: {
            'ad': $bp_t('完成巨量引擎工作台的的账户绑定, 提高多广告账户的管理效率', ''),
            'BoundIes': $bp_t('完成巨量引擎工作台的的企业号绑定, 提高广告与企业号的联动效率', ''),
            'clickToGo': $bp_t('点击前往', ''),
          }
        },
        noValidBalance: false,
        trackBindBpShow: true,
        showNoBalance: true,
        showAdvStatus: true,
        showPaySMB: true,
        showSMBModal: false,
        showVerticalCarOfflineRemind: true,
        showEducationFullIndustryRemind: true,
        showFeed2Search2Search: false,
        showQuickTurnAuto: false,
        quickTurnAutoList: [],
        feed2SearchData: [], // 用来暂存推荐计划的数据
        feed2SearchTip: '', // 快投转直投提示文案
        quickTurnAutoTip: '', // 快投转省心投文案
        hasDConvert: false,
        quickSearch2SearchShow: false,
        quickTurnAutoModalShow: false,
        smbPayModal: {
          accountFee: 0,
          cashBalance: 0,
          agree: true,
          showAgreement: false
        },
        showDiagnosis: false,
        showAccountDiagnosis: false,
        showUpgrafeNotifyStatus: false,
        showQuotaHackFeedStatus: true,
        showQuotaHackSearchStatus: true,
        accountDiagnosisData: {
          frontText: [],
          frontLink: ''
        },
        upgrafeNotifyStatus: { text: '' },
        diagnosis: {
          show: false,
          front_guidance: '',
          jump_link_text: '',
          jump_link: ''
        },
        isShowAccountFee: (GLOBAL_VAR.advertiser.status ===
          advertiserStatus.STATUS_WAIT_FOR_ACCOUNT_FEE.toString()),
        globalPushEnable: json.catchableParse(GLOBAL_VAR.globalPushEnable),
        verticalCarOfflineRemind: GLOBAL_VAR.verticalIndustryRules && GLOBAL_VAR.verticalIndustryRules.vertical_car_offline_remind && !GLOBAL_VAR.verticalIndustryRules.vertical_car_offline,
        educationFullIndustryRemind: GLOBAL_VAR.verticalIndustryRules && GLOBAL_VAR.verticalIndustryRules.vertical_education,
        globalPushText: GLOBAL_VAR.globalPushText,
        rechareUrl: '/cg_trade/finance/wallet?from_app=ad&page=charge',
        punishReason: [],
        punishTime: '',
        industryOfflineTips,
        dpaLibraryListUrl: `${tool.getBusinessHost()}/site/asset/dpa/pages/library/list`,
        hackStatus: {}, // hack的状态
        showSupplement: false,
        showExtention: false,
        cont_id: 0,
        datatime: '',
        isList: false,
      }
    },
    watch: {
      tipsLevel: function () {
        const leftAlert = alertStatusList.slice(alertStatusList.indexOf(this.tipsTag) + 1)
        this.isLastTip = !(leftAlert.findIndex(alertName => this[alertName]) >= 0)
      },
      showSMBModal: function () {
        this.getAccountFeeInfo()
      },
      showDiagnosisAlert() {
        this.tracerDiagnosis()
      },
      showAccountDiagnosisAlert() {
        this.tracerAccountDiagnosis()
      },
      showAccountDiagnosisAlert() {
        this.tracerAccountDiagnosis()
      },
    },
    created() {
      // 获取quota小黄条的状态
      this.isHackWarning()
    },
    mounted () {
      if (window.location.pathname === '/pages/promotion.html') {
        const onTTIHandler = e => {
          if (e?.detail?.isTTI) {
            this.getShowRechargeData()
            this.getAdvPunishReason()
            this.getUpgrafeNotifyStatus()
            this.tracerDiagnosis()
            this.getDiagnosisData()
            // 命中省心投白名单，展示快转直省心投数据
            this.getAccountDiagnosisData()
            window.removeEventListener('ttistagechange', onTTIHandler, true)
          }
        }
        window.addEventListener('ttistagechange', onTTIHandler, true)
        try {
          // 监听容器子元素变化，触发window resize，解决展示tips信息导航条不计算问题
          const observer = new MutationObserver((mutationList, observer) => {
            try {
              window.dispatchEvent(new Event("resize"));
            } catch (e) {
              console.error("tips container trigger resize error", e);
            }
          });
          observer.observe(this.$refs.tipsContainerNode, {
            childList: true,
            attributes: false,
            subtree: false,
          });
        } catch (e) {
          console.error("set tips container observer error", e);
        }
      } else {
        this.getShowRechargeData()
        this.getAdvPunishReason()
        this.getUpgrafeNotifyStatus()
        this.tracerDiagnosis()
        // 待导航头globalvar加载完
        setTimeout(() => {
          this.getShowSupplement()
          this.getShowExtention()
        }, 3000)
      }
    },
    methods: {
      getQueryVariable(variable){
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i=0;i<vars.length;i++) {
          let pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      },
      supplementTrack() {
        window.teaEventV1('add_contract_contacts_yellow_bar_click_to_fill_in')
      },
      extensionTrack() {
        window.teaEventV1('contract_renewal_yellow_bar_click_to_fill_in')
      },
      async getShowSupplement(){
        // this.showSupplement = true
        //此弹窗是否展示过 频控
        const shownModal = localStorage.getItem('shown_supplement_contract_modal');
        if (window.GLOBAL_VAR_API && window.GLOBAL_VAR_API.advertiserAgent && window.GLOBAL_VAR_API.advertiserAgent.id) {
          return false
        }
        if (shownModal) return false
        //判断资质认证是否弹出   不需要资质认证弹框
        let name=`isTriggeredNewUserGuide_${this.getQueryVariable('aadvid')}`
        // const cookieValue = document.cookie ? document.cookie.match(new RegExp(`"(^|${name})"+"=([^;]*)(;|$)",'g')`))[0]?.split("=")[1] : null
        let cookieValue = false;
        if (document.cookie && document.cookie !== '') {
          let cookies = document.cookie.split(';');
          for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
            }
          }
        }
        if (!cookieValue && window.GLOBAL_VAR.advertiser.status === 10) return false // 若资质认证弹窗未弹出 不展示签约弹窗
        //是否帐密登录
        const loginWayResp  = await BUI.fetch({
          contentType: 'application/json',
          url: Apis.account.loginWay
        })
        if (loginWayResp.code === 0) {
          const { login_type } = loginWayResp.data
          if (loginWayResp.data && Boolean(login_type) !== true) {
            //判断客户是否允许自主签约
            const customersResp  = await BUI.fetch({
              contentType: 'application/json',
              url: Apis.account.contractCustomers,
            })
            if (customersResp.code === 0) {
              const customers = customersResp.data.customers
              if (customers.length === 1) { // 是否只有一个crmid
                if (customers[0].category === 8) return false  //VIP大型客户的客户资质
                const employee_id = customers[0].sales_id
                const employeeResp  = await BUI.update({
                  contentType: 'application/json',
                  url: Apis.account.contractEmployeeInfo,
                  data: JSON.stringify({ employee_id })
                });

                if(employeeResp.code === 0) {
                  const eligible = employeeResp.data.eligible
                  //bff根据判断销售、销售在职状态、以及销售部门，返回是否允许创建合同
                  if (eligible) {
                      //判断一些个认证关系
                      const statusResp  = await BUI.fetch({
                        contentType: 'application/json',
                        url: Apis.account.contractCreateStatus
                      });
                      if (statusResp.code === 0) {
                        const { verify_status, subject_status, ca_status } = statusResp.data;
                        if(verify_status != 3) {
                          //判断客户是否完成对公验证   todo改为3
                          return false;
                        } else if(subject_status != 3) {
                          //判断客户是否完成主体验证
                          return false;
                        } else if(ca_status != 3) {
                          //判断是否已有CA签章
                          return false;
                        } else {
                          BUI.fetch({
                            contentType: 'application/json',
                            url: Apis.account.contractList,
                            success: (resp) => {
                              //判断新客户 =》 有 已生效 的合同
                              const newCustomer = resp.data && resp.data.length && resp.data.some(item=> item.master_cont.status === 2 && (item.master_cont.archive_status === 3 || item.master_cont.archive_status === 2))
                              if (newCustomer) {
                                const cont_id = resp.data.filter(item => item.master_cont.status === 2 && (item.master_cont.archive_status === 3 || item.master_cont.archive_status === 2)).sort((a,b) => {
                                  return new Date(b.end_date).getTime() - new Date(a.end_date).getTime()
                                })[0].master_cont.cont_id
                                this.cont_id = cont_id
                                BUI.fetch({
                                  contentType: 'application/json',
                                  url: Apis.account.contractSupplement,
                                  data: { cont_id },
                                  success: (resp) => {
                                    // 补充协议合同不存在审批中
                                    const supplements_option1 = resp.data && resp.data.supplement_list && resp.data.supplement_list.length && !resp.data.supplement_list.some(item => item.basic_info.approval_status === 2)
                                    // 合同状态不为已生效 && 未生效、补充协议合同类型in 129 131 229 && 审批状态审批通过 && 归档状态未归档
                                    const supplements_option2 = resp.data && resp.data.supplement_list && resp.data.supplement_list.length && !resp.data.supplement_list.some(item => (item.basic_info.status === 2 || item.basic_info.status === 1)
                                      && (item.basic_info.cont_type === 129 || item.basic_info.cont_type === 131 || item.basic_info.cont_type === 229)
                                      && (item.basic_info.approval_status === 5)
                                      && (item.basic_info.archive_status === 1))
                                    if ((supplements_option1 && supplements_option2) || !resp.data.supplement_list.length) {
                                      BUI.fetch({
                                        contentType: 'application/json',
                                        url: Apis.account.contractTel,
                                        success: (resp) => {
                                          // todo 前面加！判断非
                                          const hasTel = resp.data.length && resp.data.some(item => item.contract_customer_info_list.some(item => item?.contact_phone_number) || item.authorization_info?.contact_phone_number)
                                          if (!hasTel) {
                                            this.showSupplement = true
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                  }
                }
              }
            }
          }
        }
      },
      async getShowExtention () {
        // this.showExtention = true
        // 频控
        // 判断今天是否在22年
        const today = new Date().getTime()
        const is_22 = today < dayjs('2022-12-31').endOf('day').valueOf()
        if (window.GLOBAL_VAR_API && window.GLOBAL_VAR_API.advertiserAgent && window.GLOBAL_VAR_API.advertiserAgent.id) {
          return false
        }
        const nowTime = new Date().getTime()
        const lastTime = Number(localStorage.getItem('shown_extention_contract_modal'))
        if (lastTime && lastTime > nowTime) {
          return false
        }
        //判断资质认证是否弹出   不需要资质认证弹框
        let name=`isTriggeredNewUserGuide_${this.getQueryVariable('aadvid')}`
        // const cookieValue = document.cookie ? document.cookie.match(new RegExp(`"(^|${name})"+"=([^;]*)(;|$)",'g')`))[0]?.split("=")[1] : null
        let cookieValue = false;
        if (document.cookie && document.cookie !== '') {
          let cookies = document.cookie.split(';');
          for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
            }
          }
        }
        if (!cookieValue && window.GLOBAL_VAR.advertiser.status === 10) return // 若资质认证弹窗未弹出 不展示签约弹窗
        //是否帐密登录
        const loginWayResp  = await BUI.fetch({
          contentType: 'application/json',
          url: Apis.account.loginWay
        })
        if (loginWayResp.code === 0) {
          const { login_type } = loginWayResp.data
          if (Boolean(login_type)) this.isList = true
          if (loginWayResp.data) {
            //判断客户是否允许自主签约
            const customersResp  = await BUI.fetch({
              contentType: 'application/json',
              url: Apis.account.contractCustomers,
            })
            if (customersResp.code === 0) {
              const customers = customersResp.data.customers
              if (customers.length === 1) { // 是否只有一个crmid
                // if (customers[0].category === 8) return  //VIP大型客户的客户资质
                const employee_id = customers[0].sales_id
                const employeeResp  = await BUI.update({
                  contentType: 'application/json',
                  url: Apis.account.contractEmployeeInfo,
                  data: JSON.stringify({ employee_id })
                });

                if(employeeResp.code === 0) {
                  const eligible = employeeResp.data.eligible
                  //bff根据判断销售、销售在职状态、以及销售部门，返回是否允许创建合同
                  if (!eligible) return false
                      //判断一些个认证关系
                      const statusResp  = await BUI.fetch({
                        contentType: 'application/json',
                        url: Apis.account.contractCreateStatus
                      });
                      if (statusResp.code === 0) {
                        const { verify_status, subject_status, ca_status } = statusResp.data;
                        if(verify_status != 3) {
                          //判断客户是否完成对公验证   todo改为3
                          this.isList = true
                        } else if(subject_status != 3) {
                          //判断客户是否完成主体验证
                          this.isList = true
                        } else if(ca_status != 3) {
                          //判断是否已有CA签章
                          this.isList = true
                        }
                          BUI.fetch({
                            contentType: 'application/json',
                            url: Apis.account.contractList,
                            success: (resp) => {
                              //判断新客户 =》 存在已生效的合同且归档中/已归档
                              const customer_option1 = resp.data && resp.data.length && resp.data.some(item=> item.master_cont.status === 2 && (item.master_cont.archive_status === 3 || item.master_cont.archive_status === 2))
                              // 不存在未生效已通过的合同
                              const customer_option2 = resp.data && resp.data.length && !resp.data.some(item=> item.master_cont.status === 1 && item.master_cont.approval_status === 5)
                              // 不存在结束时间为"2023-12-31"的合同
                              const not_valide = resp.data && resp.data.length && resp.data.some(item => item.end_date == "2023-12-31")
                              if (customer_option1 && customer_option2) {
                                const contDate = resp.data.filter(item => (item.master_cont.cont_type === 102) && item.master_cont.status === 2 && (item.master_cont.archive_status === 3 || item.master_cont.archive_status === 2)).sort((a,b) => {
                                  return new Date(b.end_date).getTime() - new Date(a.end_date).getTime()
                                })[0].end_date
                                this.datatime = JSON.stringify(new Date(contDate).getTime())
                                const closeTime = new Date(contDate).getTime() -  new Date().getTime()
                                if (closeTime < 86400000 * 30 || (is_22 && !not_valide)) {
                                  this.showExtention = true
                                }
                              }
                            }
                          })
                      }

                }
              }
            }
          }
        }
      },
      tracerDiagnosis() {
        const timeLessThanOneDay = (this.timeLessThan(this.Keys.showDiagnosis))
        if((timeLessThanOneDay || !this.showDiagnosis) && this.tipsTag === 'showDiagnosisAlert') {
          window.teaEventV1('promotion_index_yellow_bar_diagnosis_show', () => {
            return {
              status: timeLessThanOneDay ? 3 : 4,
              showid
            }
          })
        }
      },
      tracerAccountDiagnosis () {
        if(this.showAccountDiagnosisAlert) {
          window.teaEventV1('promotion_index_bule_tip_presentation', () => {
            return {
              adv_id: GLOBAL_VAR.advertiser.id,
            }
          })
        }
      },
      tracerClick({ tipsLevel, text = '', tipsTag = '' }) {
        if(tipsTag === 'showDiagnosisAlert') {
          window.teaEventV1('promotion_index_yellow_bar_diagnosis_click', () => {
            return {
              content: text,
              content_type: tipsLevel,
              content_tag: tipsTag,
              showid
            }
          })
        }
        // 账户诊断点击
        if(tipsTag === 'showAccountDiagnosisAlert') {
          window.teaEventV1('promotion_index_bule_tip_click', () => {
            return {
              adv_id: GLOBAL_VAR.advertiser.id
            }
          })
        }
        window.teaEventV1('promotion_yellow_bar_link_click', () => {
          return {
            content_tag: tipsTag,
            yellow_bar_type: tipsLevel  // 小黄条点击
          }
        })
      },
      tracerShow({ tipsLevel, tipsTag = '', text = '' }) {
        window.teaEventV1('promotion_yellow_bar_type', () => {
          return {
            content_tag: tipsTag,
            yellow_bar_type: tipsLevel  // 小黄条出现
          }
        })
        window.teaEventV1('promotion_index_yellow_bar_diagnosis_show', () => {
          return {
            content_tag: tipsTag,
            status: tipsTag === 'showDiagnosisAlert' ? 1 : 2,
            content: text,
            content_type: tipsLevel,
            showid
          }
        })
        return ''
      },
      isHackWarning() { // 接口获取小黄条提示
        BUI.fetch({
          url: Apis.account.getHackStatus,
          success: res => {
            this.hackStatus = res?.data || {}
            console.log(this.hackStatus, 'this.hackStatus');
          },
          error: err => {
            console.log('获取quota hack warn失败: ', err)
            reject(err)
          }
        })
      },
      getHackText(type) {
        try {
          const text = type === 'feed' ? '所有广告' : '搜索广告'
          return {
            1: `您当前账户下的${text}计划已经接近或超过在投计划配额，且低效计划过多，已经严重影响账户健康度，可能面临限制投放的风险，为避免影响广告正常投放，建议您及时`,
            2: `您当前账户下的${text}计划已经接近或超过在投计划配额，且低效计划过多，已被限制投放，如需恢复请及时`,
            3: `您当前账户下的${text}计划已经接近或超过在投计划配额，且低效计划过多，已被限制投放，请及时清理低效计划后，联系销售或工单反馈进行解除限制申诉`
          }[this.hackStatus[type]]
        } catch (e) {
          console.log('quota' + e);
        }
      },
      setCloseTime (key) {
        window.localStorage.setItem(this.closeTimeTag + key, (new Date()).getTime().toString())
      },
      // 关闭时间应该和用户有关，不同用户的提示时间互不影响。
      setCloseTimeWithUid (key) {
        window.localStorage.setItem(this.closeTimeTag + key + '_' +  GLOBAL_VAR.coreUser.id, (+new Date()).toString())
      },
      getCloseTime (key) {
        return window.localStorage.getItem(this.closeTimeTag + key)
      },
      getCloseTimeWithUid (key) {
        return window.localStorage.getItem(this.closeTimeTag + key + '_' + GLOBAL_VAR.coreUser.id)
      },
      timeLessThan (key, ms = this.oneDayMillSeconds) {
        let ret = false
        let curKeyCloseTime = window.localStorage.getItem(this.closeTimeTag + key)
        if (curKeyCloseTime) {
          curKeyCloseTime = parseInt(curKeyCloseTime)
          const todayTime = (new Date()).getTime()
          if (todayTime <= curKeyCloseTime + ms ) {
            ret = true
          }
        }

        return ret
      },
      getAccountBalance() {
        Promise.all([this.getValidAccountBalance(), this.getAccountInfo()]).then(values => {
          this.noValidBalance = values[0].valid_abs <= 0 && (!values[1].is_share_wallet || !values[1].advertiser_share_balance)
        }).catch(e => {
          this.noValidBalance = false
        })
      },
      getValidAccountBalance () {
        return new Promise((resolve, reject) => {
          BUI.fetch({
            url: Apis.account.balance,
            success: (resp) => {
              if (resp && resp.status === 'success' && resp.data) {
                resolve(resp.data)
              }
            },
            error: (err) => {
              this.$message($bp_t('获取账户余额失败，请刷新重试或联系管理员：', 'bp.promotion_failed_to_get_the_account_balance') + err.status, 'error')
              reject(error)
            }
          })
        })
      },
      getAccountInfo () {
        return new Promise((resolve, reject) => {
          BUI.fetch({
            url: Apis.dashboard.account_info,
            data: {},
            success: (resp) => {
              if (resp.code === 0) {
                if (resp.data.is_share_wallet) {
                  resp.data.advertiser_share_balance = parseFloat(resp.data.advertiser_share_balance)
                }
                resolve(resp.data)
              }
              else {
                reject()
              }
            }
          })
        })
      },
      getAccountFeeInfo() {
        BUI.fetch({
          url: Apis.account.fee,
          // url: 'https://mock.bytedance.net/mock/5d08e32467d0ef01ffdefce9/promotion/account_fee_info',
          success: (resp) => {
            if (resp && resp.code === 0) {
              this.smbPayModal.accountFee = resp.data.account_fee;
              this.smbPayModal.cashBalance = resp.data.cash_balance;
            }
          },
          error: (err) => {
            this.$message($bp_t('获取账户费用失败，请刷新重试或联系管理员：', 'bp.promotion_failed_to_get_the_account_fee') + err.status, 'error')
          }
        });
      },
      onCloseGrantMoney () {
        this.showActivityByUser = false
        this.setCloseTime(this.Keys.showActivity)
      },
      onCloseAdvStatus () {
        this.showAdvStatus = false
        this.setCloseTime(this.Keys.showAdvStatus)
      },
      onCloseSupplement () {
        this.showSupplement = false
        // this.setCloseTime(this.Keys.showSupplement)
      },
      onCloseExtention () {
        this.showExtention = false
        // this.setCloseTime(this.Keys.showExtention)
      },
      onCloseNoBalance () {
        this.showNoBalance = false
        this.setCloseTime(this.Keys.showNoBalance)
      },
      onClosePaySMB () {
        this.showPaySMB = false
        this.setCloseTime(this.Keys.showPaySMB)
      },
      onClickSMBRecharge () {
        window.open(this.globalUpdateQuery(this.rechareUrl))
      },
      getDiagnosisData () {
        BUI.update({
          url: Apis.diagnosis.frontGuidance,
          // url: 'https://mock.bytedance.net/mock/5d08e32467d0ef01ffdefce9/promotion/diagnosis-tip',
          data: JSON.stringify([{ advid: parseInt(GLOBAL_VAR.advertiser.id), bid: 1000000, delivery_status: 1 }]),
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          success: (resp) => {
            if (!resp) {
              return;
            }
            if (parseInt(resp.status_code) === 0) {
              this.diagnosis.front_guidance = resp.front_guidance;
              this.diagnosis.jump_link_text = resp.jump_link_text;
              this.diagnosis.jump_link = resp.jump_link;
              this.showDiagnosis = true
            }
          }
        });
      },
      getAccountDiagnosisData () {
        const checkAccountDiagnosis = tool.isSupported(GLOBAL_VAR?.adver_func?.search_ads_account_diagnosis)
        if (!checkAccountDiagnosis) {
          return
        }
        BUI.fetch({
          url: Apis.diagnosis.accountGuidance,
          success: (resp) => {
            const resData = resp.data || {}
            const frontText = resData?.front_guidance ? resData?.front_guidance?.split('#') : []
            const frontLink = resData?.jump_link || ''
            if (frontText.length) {
              this.accountDiagnosisData = {
                frontText,
                frontLink,
              }
              this.showAccountDiagnosis = true
            } else {
              this.showAccountDiagnosis = false
            }
          },
          error: (err) => {
            console.error(`获取账户诊断提示数据失败：${e}`)
          }
        });
      },
      // 获取方舟状态请求
      getUpgrafeNotifyStatus() {
        BUI.update({
          url: Apis.account.getUpdateNotifyStatus,
          success: (resp) => {
            const resData = resp.data || {};
            const agentId = resData?.agent_info.agentId;
            const { status, deadlineTime = ''} = resData?.notify_status;
            const timeList = deadlineTime.split(' ');
            const daylist = timeList[0]?.split('-');
            const day = `${daylist[0]}年${daylist[1]}月${daylist[2]}日`
            const text = status === NotifyStatusEnum.WARNING
              ? `当前账户未完成合规升级，存在安全风险，请在${day}前联系代理商完成合规升级，逾期未完成将禁用新建及修改组/计划/创意的能力`
              : '由于当前账户逾期未完成合规升级，新建及修改组/计划/创意的能力已禁用，请尽快联系代理商完成升级'
            this.upgrafeNotifyStatus = { text }
            this.showUpgrafeNotifyStatus = agentId && status != NotifyStatusEnum.SAFETY
          },
          error: (err) => {
            console.error(`获取方舟账户提示数据失败：${e}`)
            this.showUpgrafeNotifyStatus = false;
          }
        });
      },
      hideDiagnosis (e, text='') {
        if(this.tipsTag === 'showDiagnosisAlert') {
          window.teaEventV1('promotion_index_yellow_bar_diagnosis_close', () => {
            return {
              content: text,
              content_tag: this.tipsTag,
              content_type: this.tipsLevel,
              showid
            }
          })
        }
        this.showDiagnosis = false
        this.setCloseTime(this.Keys.showDiagnosis)
      },
      hideAccountDiagnosis (e) {
        this.showAccountDiagnosis = false
        this.setCloseTime(this.Keys.showAccountDiagnosis)
      },
      hideUpgrafeNotifyStatusAlert (e) {
        this.showUpgrafeNotifyStatus = false
        this.setCloseTime(this.Keys.showUpgrafeNotifyStatus)
      },
      hideQuotaHackFeedAlert() {
        this.showQuotaHackFeedStatus = false
      },
      hideQuotaHackSearchAlert() {
        this.showQuotaHackSearchStatus = false
      },
      getShowRechargeData() {
        BUI.fetch({
          url: Apis.account.show_recharge,
          success: (resp) => {
            if (resp.code === 0) {
              const isEnable = (GLOBAL_VAR.advertiser.status === advertiserStatus.ENABLE.toString())
              if ((isEnable || this.isShowAccountFee) && resp.data.show_recharge) {
                this.getAccountBalance()
              }
            }
          }
        })
      },
      getAdvPunishReason() {
        let _this = this
        BUI.fetch({
          url: `${Apis.account.accountAudit}?aadvid=${GLOBAL_VAR.advertiser.id}`,
          beforeSend () {
            // 覆盖 src/basic/boot/ajax.js 中headers设置，不可以传aadvid  字段
          },
          success: (resp) => {
            if (resp.code === 0) {
              const reasons = (resp.data && resp.data.data) || []
              const reasonLen = reasons.length
              reasons.forEach((reason, index) => {
                if (index === reasonLen - 1) {
                  _this.punishTime = reason.punish_time
                }
                const textStart = reasonLen > 1 ? `原因${index + 1}:` : ''
                const realStr = reason.reason
                const reg = new RegExp(/^[a-zA-z0-9\u4E00-\u9FA5]*$/)
                // 末尾是非字母数字中文
                const showStr = !realStr.substring(realStr.length - 1).match(reg) ? realStr.substring(0, realStr.length - 1) : realStr
                _this.punishReason.push(`${textStart}${showStr}`)
              })
            } else {
              _this.$message(resp.msg, 'error')
            }
          }
        })
      },
      onCloseVerticalCarOfflineRemind () {
        this.showVerticalCarOfflineRemind = false;
        this.setCloseTime(this.Keys.showVerticalCarOfflineRemind);
      },
      onCloseVerticalEducationFullRemind () {
        this.showEducationFullIndustryRemind = false;
        this.setCloseTime(this.Keys.showEducationFullIndustryRemind);
      },
      // 获得快转直信息
      getFeed2Search2SearchInfo () {
        BUI.fetch({
          url: Apis.promotion.feed_to_search_to_search_get_recommend_info,
          success: (resp) => {
            if (resp.code === 0) {
              const {
                cost,
                convert,
                convert_ratio,
                feed_convert_ratio,
                has_d_cost,
                improve_space_rate
              } = {...resp.data}

              this.hasDConvert = has_d_cost

              const [
                secCost, secConvert, secConvertRatio, secImproveSpaceRate
              ] = [cost, convert, convert_ratio, improve_space_rate].map(item => tool.secHtml(`${item}`))

              if (has_d_cost) {
                this.feed2SearchTip = `<span>账户内搜索快投近7日消耗<strong>${
                    secCost
                  }</strong>元。建议将部分优质快投计划创建为搜索独立计划，预计新增<strong>${
                    secImproveSpaceRate
                  }</strong>%跑量空间，</span>`
              } else {
                const lowerConvertRatioText = convert_ratio < feed_convert_ratio ? '低于账户整体转化成本' : '符合账户整体成本要求'
                this.feed2SearchTip = `<span>账户内搜索快投近7日消耗<strong>${
                    secCost
                  }</strong>元，获得<strong>${
                    secConvert
                  }</strong>个额外转化，转化成本<strong>${
                    secConvertRatio
                  }</strong>，${
                    lowerConvertRatioText
                  }。建议将部分优质快投计划创建为搜索独立计划，预计新增<strong>${
                    secImproveSpaceRate
                  }</strong>%跑量空间，</span>`
              }
              // 有实际接口数据就发埋点，当作兜底
              window.teaEventV1('promotion_index_feedtosearch_notification_show', () => {
                return {
                  adv_id: GLOBAL_VAR.advertiser.id
                }
              })
              //  展示小黄条及文案
              this.showFeed2Search2Search = true
            }
          },
          error: (err) => {
            // 展示快转直入口的埋点
            window.teaEventV1('promotion_index_feedtosearch_notification', () => {
              return {
                adv_id: GLOBAL_VAR.advertiser.id,
                status: 4 // 因为接口波动无法正常展示
              }
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss">
  $basic-space: 8px;
  $sm-font-size: 12px;
  .global-tips-container {
    padding: 0 16px;
    margin-bottom: 10px; // 样式和推广管理对其
    display: flex;
    flex-direction: column;

    .byted-alert {
      display: flex;
      font-size: $sm-font-size;
      align-items: center; // ×不垂直居中
      margin-top: $basic-space;
      margin-bottom: $basic-space;
      height: 30px; // 高度统一修改，12px的字对30px的高
      border: none; // 样式和推广管理对其
      &:last-child {
        margin-bottom: $basic-space;
      }
      a {
        cursor: pointer;
        color: #2F88FF;
        text-decoration: none;
      }
      .bui-alert-close {
        position: relative;
        top: -1px;
      }
      svg {
        width: 13px;
        height: 13px;
      }
    }
  }

  .pay-smb-modal {
    .bui-modal-dialog {
      width: 520px !important;
    }
    .no-balance-alert {
      width: 243px;
      margin-bottom: 24px;
    }
    .account-info-wrapper {
      .content-row {
        width: 100%;
        display: flex;
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
        $row-height: 22px;
        .content-label-item {
          white-space: nowrap;
          margin-right: 20px;
          line-height: $row-height;
        }
        .content-item {
          font-size:14px;
          font-family:PingFangSC-Semibold;
          font-weight:600;
          color: #333;
          line-height: $row-height;
        }
      }
    }
    .tips {
      font-size: 12px;
      line-height:20px;
      color: #999;
      margin-top: 16px;
    }
    .checkbox-wrapper {
      float: left;
      height: 34px;
      display: flex;
      align-items: center;
    }
  }

  .tech-agreement-modal {
    .bui-modal-dialog {
      width: 800px !important;
    }
  }

  .close-text {
    color: rgb(145, 152, 161);
  }
</style>
